import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) { setError(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F5F7FA] px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8" data-testid="forgot-logo">
          <img src="/dazlac-logo.png" alt="Dazlac" className="h-10 w-auto" />
        </div>
        {sent ? (
          <div className="rounded-xl border border-slate-200 bg-white p-6 text-center">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-50 text-emerald-600"><MailCheck className="h-6 w-6" /></div>
            <h2 className="text-lg font-semibold text-slate-900">Check your inbox</h2>
            <p className="mt-1 text-sm text-slate-500">If that email is registered, we've sent a reset link. It expires in 1 hour.</p>
            <Link to="/login" className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-[#0057A8]"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold tracking-tight text-slate-900">Reset password</h2>
            <p className="mt-1 text-sm text-slate-500">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold text-slate-600">Email</Label>
                <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@dazlac.com" className="h-11" />
              </div>
              {error && <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</div>}
              <Button data-testid="forgot-submit" type="submit" disabled={loading} className="h-11 w-full font-semibold">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-slate-700"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
